import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { FiSave } from "react-icons/fi";
import useTranslations from "../../hooks/useTranslations";
import useUserLanguage from "../../hooks/useUserLanguage";

const BASE_URL = process.env.REACT_APP_API_BASE_URL;

const SettingsIpEditForm = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const language = useUserLanguage();
  const { translations } = useTranslations(language);
  const getText = (key, fallback) => translations[key] || fallback;

  const [formData, setFormData] = useState({
    title: "",
    ip: ""
  });

  const [loading, setLoading] = useState(true);

  // IP'yi getir
  useEffect(() => {
    const fetchIP = async () => {
      try {
        const response = await axios.get(`${BASE_URL}/api/ip/${id}`);
        setFormData({
          title: response.data.title,
          ip: response.data.ip
        });
      } catch (error) {
        console.error("❌ IP verisi alınamadı:", error);
        toast.error("IP bilgisi alınamadı!");
      } finally {
        setLoading(false);
      }
    };

    fetchIP();
  }, [id]);

  // Input değişimi
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value
    }));
  };

  // Güncelle
  const updateIP = async () => {
    if (!formData.title.trim() || !formData.ip.trim()) {
      toast.warn("Başlık ve IP adresi boş olamaz!");
      return;
    }

    try {
      await axios.put(`${BASE_URL}/api/ip/${id}`, formData);
      toast.success("IP başarıyla güncellendi!");
      setTimeout(() => navigate("/settings/ip"), 1000);
    } catch (error) {
      console.error("❌ Güncelleme başarısız:", error);
      toast.error("IP güncellenemedi!");
    }
  };

  return (
    <div className="container mt-4">
      <ToastContainer />
      <div className="card card-body">

        {loading ? (
          <p>Yükleniyor...</p>
        ) : (
          <>
            <div className="mb-3">
              <label className="form-label fw-bold">{getText("MENU_SETTINGS_TITLE")}</label>
              <input
                type="text"
                name="title"
                className="form-control"
                value={formData.title}
                onChange={handleChange}
              />
            </div>

            <div className="mb-3">
              <label className="form-label fw-bold">{getText("LABEL_IP_ADDRESS")}</label>
              <input
                type="text"
                name="Ip"
                className="form-control"
                value={formData.ip}
                onChange={handleChange}
              />
            </div>

            <div className="d-flex justify-content-center">
              <button className="btn btn-primary" onClick={updateIP}>
                <FiSave className="me-2" /> {getText("SAVE_BTN")}
              </button>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default SettingsIpEditForm;
